import { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

const formatNumber = (value) => parseFloat(value || 0).toLocaleString(navigator.language, { minimumFractionDigits: 3 });

const EmissionsDisaggregatedByCustomCategoryRow = ({ customCategory, customCategoryData, organisation, organisations }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const toggleRow = (id) => {
    setExpandedRows((prevExpandedRows) => {
      const newExpandedRows = new Set(prevExpandedRows);
      if (newExpandedRows.has(id)) {
        newExpandedRows.delete(id);
      } else {
        newExpandedRows.add(id);
      }
      return newExpandedRows;
    });
  };

  if (!customCategoryData) {
    return null;
  }

  return (
    <tr>
      <td className='w-1/5 text-left'>{customCategory}</td>
      <td className='w-1/5 text-center'>
        {organisations && organisations?.find((item) => item.id === organisation)?.name}
      </td>
      <td className='w-1/5'>
        <div className='hidden sm:block text-right'>
          <span className='toggle-location'>
            {formatNumber(customCategoryData && customCategoryData.co2e ? customCategoryData.co2e.toFixed(3) : '0.000')}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              customCategoryData && customCategoryData.marketScope
                ? _.sum(Object.values(customCategoryData.marketScope))
                : '0.000',
            )}
          </span>
        </div>
        <div className='flex sm:hidden flex-col justify-end'>
          <span className='toggle-location'>
            {formatNumber(customCategoryData && customCategoryData.co2e ? customCategoryData.co2e.toFixed(3) : '0.000')}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              customCategoryData && customCategoryData.marketScope
                ? _.sum(Object.values(customCategoryData.marketScope))
                : '0.000',
            )}
          </span>
          <button className='text-xs text-primary underline mt-1 text-right' onClick={() => toggleRow(customCategory)}>
            {expandedRows.has(customCategory) ? 'Hide Details' : 'View Details'}
          </button>
          {expandedRows.has(customCategory) && (
            <div className='usage-detail normal-case text-muted-foreground'>
              <span className='toggle-location'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.scope[1] ? customCategoryData.scope[1].toFixed(3) : '0.000',
                  )}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.scope[2] ? customCategoryData.scope[2].toFixed(3) : '0.000',
                  )}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.scope[3] ? customCategoryData.scope[3].toFixed(3) : '0.000',
                  )}
                </p>
              </span>
              <span className='toggle-market'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.marketScope[1]
                      ? customCategoryData.marketScope[1].toFixed(3)
                      : customCategoryData && customCategoryData.scope[1]
                        ? customCategoryData.scope[1].toFixed(3)
                        : '0.000',
                  )}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.marketScope[2]
                      ? customCategoryData.marketScope[2].toFixed(3)
                      : '0.000',
                  )}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(
                    customCategoryData && customCategoryData.marketScope[3]
                      ? customCategoryData.marketScope[3].toFixed(3)
                      : '0.000',
                  )}
                </p>
              </span>
            </div>
          )}
        </div>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            customCategoryData && customCategoryData.scope[1] ? customCategoryData.scope[1].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            customCategoryData && customCategoryData.marketScope[1]
              ? customCategoryData.marketScope[1].toFixed(3)
              : customCategoryData && customCategoryData.scope[1]
                ? customCategoryData.scope[1].toFixed(3)
                : '0.000',
          )}
        </span>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            customCategoryData && customCategoryData.scope[2] ? customCategoryData.scope[2].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            customCategoryData && customCategoryData.marketScope[2]
              ? customCategoryData.marketScope[2].toFixed(3)
              : '0.000',
          )}
        </span>
      </td>
      <td className='w-1/5 hidden sm:table-cell text-right'>
        <span className='toggle-location'>
          {formatNumber(
            customCategoryData && customCategoryData.scope[3] ? customCategoryData.scope[3].toFixed(3) : '0.000',
          )}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            customCategoryData && customCategoryData.marketScope[3]
              ? customCategoryData.marketScope[3].toFixed(3)
              : '0.000',
          )}
        </span>
      </td>
    </tr>
  );
};

const mapStateToProps = (state) => {
  const adminOrgs = state.admin?.organisations;
  const orgnaisationList = state.organisation?.list;
  const { cyfAdmin, whiteLabelAdmin } = state.profile?.details || {};
  const adminUser = cyfAdmin || whiteLabelAdmin || false;

  return {
    organisations: adminUser ? adminOrgs : orgnaisationList,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsDisaggregatedByCustomCategoryRow);
